import 'twin.macro';
import 'styled-components/macro';

import { Modal, ModalBody } from 'play/molecules/modal/Modal';
import { TrackLoadingIndicator } from 'play/molecules/track-loading-indicator/TrackLoadingIndicator';

interface LoadingModalProps {
  open: boolean;
  message: string;
  onClose?: () => void;
}

export const LoadingModal = ({ open, message, onClose }: LoadingModalProps) => (
  <Modal open={open} onClose={onClose} width="small" hideCloseIcon tw="bg-blue-dark border-1 border-gray-50">
    <ModalBody tw="py-3">
      <TrackLoadingIndicator loading={open} title={message} subtitle="This may take a while" />
    </ModalBody>
  </Modal>
);
